import _ from 'lodash';

const checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');

export function likeId(id) {
  if (id == null) return false;

  if (typeof id === 'number') {
    return true;
  }

  if (typeof id === 'string') {
    return id.length === 12 || (id.length === 24 && checkForHexRegExp.test(id));
  }

  return false;
}

export function splitIdsCollection(collection) {
  const ids = [];
  const objects = [];

  if(_.isArray(collection)) {
    collection.forEach(item => {
      if(likeId(item)) {
        ids.push(item);
      } else {
        objects.push(item);
      }
    })
  }

  return { ids, objects };
}



// WEBPACK FOOTER //
// ./src/utils/store.js